import React from 'react';
import { connect } from 'react-redux';
import ErrorBoundary from 'react-error-boundary';
import { Dispatch } from 'redux';
import ErrorMessage from './Error';
import { recoverFromChunkLoadError } from '@/utils/chunkLoadRecovery';

type Props = {
    children: React.ReactNode;
    FallbackComponent?: React.ComponentType<any>;
    dispatch: Dispatch;
};

export default connect()(({ FallbackComponent = ErrorMessage, dispatch, ...rest }: Props) => (
    <ErrorBoundary
        {...rest}
        FallbackComponent={FallbackComponent}
        onError={(error) => {
            recoverFromChunkLoadError(error);
            console.error(error);
        }}
    />
));
